// extracted by mini-css-extract-plugin
module.exports = {"Quote":"Quote_Quote__m4Ni3","Verse":"Quote_Verse__1j2Tf"};